import { NavLink } from "react-router-dom";
import logo from "../assets/images/logo.png";
import { useEffect, useState } from "react";

function Header() {
  const [currentLang, setCurrentLang] = useState("en");

  useEffect(() => {
    const checkHtmlLang = () => {
      const htmlLang = document.documentElement.lang;
      if (htmlLang && htmlLang !== currentLang) {
        setCurrentLang(htmlLang);
      }
    };

    // Check every 500ms
    const interval = setInterval(checkHtmlLang, 500);

    return () => clearInterval(interval);
  }, [currentLang]);

  const translations = {
    en: {
      home: "HOME",
      about: "ABOUT",
      products: "PRODUCTS",
      contact: "CONTACT",
      bio: "TAKE ME TO bioKEMIX",
    },
    nl: {
      home: "HOME",
      about: "OVER",
      products: "PRODUCTEN",
      contact: "CONTACT",
      bio: "GA NAAR bioKEMIX",
    },
    de: {
      home: "HEIN",
      about: "UM",
      products: "PRODUKTE",
      contact: "KONTAKT",
      bio: "BRING MICH ZU bioKEMIX",
    },
  };

  const t = translations[currentLang] || translations.en;

  return (
    <header id="header-wrapper" className="d-flex">
      <div className="logo">
        <NavLink to="/">
          <img src={logo} alt="Logo" />
        </NavLink>
      </div>

      <div className="header-right">
        <div className="header-right-top d-flex align-items-center">
          <div className="header-nl2 pe-4 ms-auto">
            <div id="google_translate_element"></div>
          </div>
        </div>

        <nav id="header_nav" className="navbar navbar-expand-sm">
          <div className="container-fluid">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#mynavbar"
            >
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="mynavbar">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <NavLink className="nav-link notranslate" translate="no" to="/">
                    {t.home}
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link notranslate" translate="no" to="/about">
                    {t.about}
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link notranslate" translate="no" to="/products">
                    {t.products}
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link notranslate" translate="no" to="/contact">
                    {t.contact}
                  </NavLink>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link notranslate"
                    translate="no"
                    href="https://biokemix.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t.bio}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
